<template>
  <div class="overlay" @click.self="close">
    <div class="modal">
      <button class="close-btn" @click="close">✖</button>

      <iframe
        :src="src"
        frameborder="0"
        allowfullscreen
        loading="lazy"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "KibanaIframe",
  props: {
    src: { type: String, required: true },
  },
  emits: ["close"],

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
/* Background dim */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* Center modal box */
.modal {
  position: relative;
  width: 85%;
  height: 80vh;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 6px 25px rgba(0,0,0,0.25);
  animation: fadeIn 0.25s ease-out;
}

/* Close button */
.close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #3B82F6; /* Soft blue */
  border: none;
  color: white;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  z-index: 10;
  transition: 0.2s ease;
}

.close-btn:hover {
  background: #2563EB; /* Slightly darker on hover */
}



iframe {
  width: 100%;
  height: 100%;
  border: none;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
